export interface PaginatedRequest {
  limit?: number;
  page?: number;
  search?: string;
  sortBy?: Sort[];
  filters?: Filter[];
}

export interface Sort {
  key: string;
  direction: 'asc' | 'desc';
}

export interface Filter {
  key: string;
  operator?: FilterOperator | FilterOperator[];
  or?: boolean;
  value: string | string[];
}

export enum FilterOperator {
  EQ = '$eq',
  NOT = '$not',
  NULL = '$null',
  IN = '$in',
  GT = '$gt',
  GTE = '$gte',
  LT = '$lt',
  LTE = '$lte',
  BTW = '$btw',
  ILIKE = '$ilike',
  SW = '$sw',
  CONTAINS = '$contains',
}

export function getUrlParamsFromPaginatedRequest(paginatedRequest: PaginatedRequest): string {
  let queryParams = `?page=${paginatedRequest.page ?? 1}&limit=${paginatedRequest.limit ?? 20}`;
  if (paginatedRequest.search) {
    queryParams += `&search=${encodeURIComponent(paginatedRequest.search)}`;
  }
  if (paginatedRequest.sortBy) {
    for (const sort of paginatedRequest.sortBy) {
      queryParams += `&sortBy=${sort.key}:${sort.direction.toUpperCase()}`;
    }
  }
  if (paginatedRequest.filters) {
    for (const filter of paginatedRequest.filters) {
      const filterValue = Array.isArray(filter.value) ? filter.value.join(',') : filter.value;
      queryParams += `&filter.${filter.key}=${filter.or ? '$or:' : ''}${resolveFilterOperator(filter.operator)}:${filterValue}`;
    }
  }
  return queryParams;
}

function resolveFilterOperator(operator: FilterOperator | FilterOperator[] | undefined): string {
  if (Array.isArray(operator)) {
    return operator.join(':');
  }
  return operator ?? FilterOperator.EQ;
}
